// Fonts are hosted with the site (no third-party font service). Browsers only
// download a font file when a theme actually uses that font.
import '@fontsource/sour-gummy/latin-400.css';
import '@fontsource/sour-gummy/latin-700.css';
import '@fontsource/oswald/latin-400.css';
import '@fontsource/oswald/latin-700.css';
import '@fontsource/bebas-neue/latin-400.css';
import '@fontsource/montserrat/latin-400.css';
import '@fontsource/montserrat/latin-700.css';
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-700.css';
import '@fontsource/roboto-slab/latin-400.css';
import '@fontsource/roboto-slab/latin-700.css';
import '@fontsource/permanent-marker/latin-400.css';
import '@fontsource/playfair-display/latin-400.css';
import '@fontsource/playfair-display/latin-700.css';

export const FONTS = {
  'sour-gummy': { label: 'Sour Gummy', stack: "'Sour Gummy', system-ui, sans-serif" },
  oswald: { label: 'Oswald', stack: "'Oswald', 'Arial Narrow', sans-serif" },
  'bebas-neue': { label: 'Bebas Neue', stack: "'Bebas Neue', 'Arial Narrow', sans-serif" },
  montserrat: { label: 'Montserrat', stack: "'Montserrat', system-ui, sans-serif" },
  inter: { label: 'Inter', stack: "'Inter', system-ui, sans-serif" },
  'roboto-slab': { label: 'Roboto Slab', stack: "'Roboto Slab', Georgia, serif" },
  'permanent-marker': { label: 'Permanent Marker', stack: "'Permanent Marker', 'Comic Sans MS', cursive" },
  'playfair-display': { label: 'Playfair Display', stack: "'Playfair Display', Georgia, serif" },
  system: { label: 'System default', stack: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif" },
} as const;

export type FontId = keyof typeof FONTS;

export const isFontId = (value: unknown): value is FontId => typeof value === 'string' && value in FONTS;
